import { render } from "./CustosApp.vue?vue&type=template&id=4322ce6a&scoped=true&ts=true"
import script from "./CustosApp.vue?vue&type=script&lang=ts"
export * from "./CustosApp.vue?vue&type=script&lang=ts"

import "./CustosApp.vue?vue&type=style&index=0&id=4322ce6a&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4322ce6a"]])

export default __exports__